import React from "react";
import { Select, Form } from 'antd';
import { isValid, isValidArray } from "../../../utils/utilities";
// import { isValid,isValidArray } from "../../../utils/utilities";

const { Option } = Select;

const ALL_VALUE = '__ALL__';

const renderAgents=(agents , showHeadOffice , showDriver)=>{
    let agentsArray=[];
    if(isValidArray(agents)&&agents.length>0){
        agents.forEach(element => {
            if(isValidArray(element)&&isValid(element.agent_name)||isValid(element.name)){
                if(element.privilege == 'Head Office'&&!showHeadOffice){

                }else if(element.privilege == 'Driver'&&!showDriver){

                }else{
                    agentsArray.push(<Option value={element.id} agent={element}>{element.name}</Option>)
                }
            }else{
                agentsArray.push(<Option value={element} agent={element}>{element}</Option>)

            }
        });
    }
    return agentsArray;
}

export const AgentsSelect = ({
    agents=['RedBus','Head Office'],
    showLabel=false,
    isManditory=true,
    showHeadOffice=true,
    showDriver=true,
    selectedAgentId=null,
    mode=null,
    fieldName='agentName',
    optionValue='id',
    showAllOption = false,
    allLabel = 'All',
}) => {
    const getAllValues = () => {
        if (!isValidArray(agents) || agents.length === 0) return [];
        return agents
            .map((element) => {
                if (isValidArray(element) && (isValid(element.agent_name) || isValid(element.name))) {
                    return optionValue === 'name' ? element.name : element.id;
                }
                return element;
            })
            .filter((v) => v != null);
    };

    const renderAgentsWithValue = (agentsList, showHO, showDr) => {
        if (!isValidArray(agentsList) || agentsList.length === 0) return [];
        return agentsList.map((element) => {
            if (isValidArray(element) && (isValid(element.agent_name) || isValid(element.name))) {
                if (element.privilege == 'Head Office' && !showHO) return null;
                if (element.privilege == 'Driver' && !showDr) return null;
                const val = optionValue === 'name' ? element.name : element.id;
                return <Option key={val} value={val} agent={element}>{element.name}</Option>;
            }
            return <Option key={element} value={element} agent={element}>{element}</Option>;
        }).filter(Boolean);
    };

    return (
        <Form.Item shouldUpdate noStyle>
            {(ctx) => {
                const allValues = getAllValues();
                const currentValue = ctx?.getFieldValue ? ctx.getFieldValue(fieldName) : undefined;
                const isMultiple = mode === 'multiple';
                const isAllSelected =
                    isMultiple &&
                    Array.isArray(currentValue) &&
                    allValues.length > 0 &&
                    currentValue.length === allValues.length;

                return (
                    <Form.Item
                        name={fieldName}
                        label={showLabel ? "Agent Name" : ''}
                        rules={[{ required: isManditory, message: 'Please input your agent!' }]}
                    >
                        <Select
                            mode={mode}
                            size="large"
                            showSearch
                            placeholder={mode === 'multiple' ? 'Select agents' : 'Select a agent'}
                            optionFilterProp="childrens"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            bordered={true}
                            className="defalut-select-style"
                            defaultValue={selectedAgentId}
                            maxTagCount={isMultiple ? 1 : undefined}
                            maxTagPlaceholder={() => (isAllSelected ? allLabel : '...')}
                            onSelect={(val) => {
                                if (!isMultiple) return;
                                if (!showAllOption) return;
                                if (val !== ALL_VALUE) return;
                                const next = [...allValues];
                                if (ctx?.setFieldsValue) {
                                    ctx.setFieldsValue({ [fieldName]: next });
                                }
                            }}
                        >
                            {showAllOption && mode === 'multiple' ? (
                                <Option key={ALL_VALUE} value={ALL_VALUE}>
                                    {allLabel}
                                </Option>
                            ) : null}
                            {mode === 'multiple' && optionValue === 'name'
                                ? renderAgentsWithValue(agents, showHeadOffice, showDriver)
                                : renderAgents(agents,showHeadOffice,showDriver)}
                        </Select>
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
}